import React from 'react'

const ShadowCard = ({children, altBg, extraStyles}) => {
  return (
    <div className={`${altBg ? 'bg-brandGrayBlue30' : 'bg-white'} shadow-thickCard rounded-xl px-8 py-16 tablet:px-14 tablet:py-[88px] ${extraStyles ? extraStyles : ''}`}>
        {
            children
        }
    </div>
  )
}

export default ShadowCard